import { ActivityMessagingDefaultField } from './ActivityMessagingDefaultField.tsx';
import { ActivityMessagingInterkabSolutionsField } from './ActivityMessagingInterkabSolutionsField.tsx';
import { ActivityMessagingInternalInformationField } from './ActivityMessagingInternalInformationField.tsx';
import { ActivityMessagingShopImageField } from './ActivityMessagingShopImageField.tsx';
import { ActivityMessagingType } from './ActivityMessagingPreview.types.ts';

export type ActivityMessagingPreviewProps = {
  type: string;
  title?: string;
  content?: string;
  jsonContent?: string;
  fileSrc?: string;
  fileName?: string;
  redirectionUrl?: string;
};

/**
 * r2wc does not update React props when an attribute is removed or set to an empty string.
 * As a workaround, we pass the string "null" from the legacy side and clean it here.
 * @see https://github.com/bitovi/react-to-web-component/issues/230
 */
function cleanAttribute(value?: string): string | undefined {
  if (!value || value === 'null') {
    return undefined;
  }

  return value;
}

export function ActivityMessagingPreview({
  type,
  title,
  content,
  jsonContent,
  fileSrc,
  fileName,
  redirectionUrl,
}: ActivityMessagingPreviewProps) {
  const cleanType = cleanAttribute(type);

  if (!cleanType) {
    return null;
  }

  const mediaProps = {
    title: cleanAttribute(title),
    content: cleanAttribute(content),
    jsonContent: cleanAttribute(jsonContent),
    fileSrc: cleanAttribute(fileSrc),
    fileName: cleanAttribute(fileName),
    redirectionUrl: cleanAttribute(redirectionUrl),
  };

  switch (cleanType) {
    case ActivityMessagingType.SHOP_IMAGE:
      return (
        <ActivityMessagingShopImageField
          fileSrc={mediaProps.fileSrc}
          redirectionUrl={redirectionUrl}
        />
      );

    case ActivityMessagingType.INFO_LBI:
      return <ActivityMessagingInternalInformationField {...mediaProps} />;

    case ActivityMessagingType.INTERKAB_SOLUTIONS:
      return <ActivityMessagingInterkabSolutionsField {...mediaProps} />;

    default:
      return (
        <ActivityMessagingDefaultField
          type={cleanType}
          title={mediaProps.title}
          content={mediaProps.content}
        />
      );
  }
}
